// extracted by mini-css-extract-plugin
export default {"new-input":"Goals_new-input__i3b1n"};